/**
 * @generated SignedSource<<9471f903c38a4991a8d60d75426d9209>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { Semver } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type DatasetVersionEditSheet$data = {
  readonly dataset: {
    readonly slug: string;
  };
  readonly id: string;
  readonly version: Semver;
  readonly " $fragmentType": "DatasetVersionEditSheet";
};
export type DatasetVersionEditSheet$key = {
  readonly " $data"?: DatasetVersionEditSheet$data;
  readonly " $fragmentSpreads": FragmentRefs<"DatasetVersionEditSheet">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DatasetVersionEditSheet",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Dataset",
      "kind": "LinkedField",
      "name": "dataset",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DatasetVersion",
  "abstractKey": null
};

(node as any).hash = "323051c9689c01ce5147484b1a1ff386";

export default node;
